import { CapKeyDtoToEntity } from "src/app/features/EmvKernelProfile/subFeatures/CapKey/services/mappers/CapKeyDtoToEntity";
import type { CapKeyDto } from "src/app/features/EmvKernelProfile/subFeatures/CapKey/types/CapKeyDto";
import type { CapKeyEntity } from "src/app/features/EmvKernelProfile/subFeatures/CapKey/types/CapKeyEntity";
import type { ResourcePageDto } from "../../../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../../../core/types/fe/entities/ResourcePageEntity";

export const CapKeyTableDtoMapper = (input: Readonly<ResourcePageDto<CapKeyDto>>): ResourcePageEntity<CapKeyEntity> => {
    return {
        list: input.list ? input.list.map(CapKeyDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
